export default __webpack_public_path__ + "static/media/banner1.cce61133.svg";